import {
  CloseCircleOutlined,
  DownloadOutlined,
  DownSquareOutlined,
  MailOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { Button, Checkbox, DatePicker, Divider, Dropdown, Empty, Form, Menu, Space, Spin, Tabs, Tag, } from 'antd';
import { xor } from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getReportByNamespaceApi } from '../../../api/customerApi';
import { DECODED_ACCESS_TOKEN, NOTIFIES } from '../../../constants/system.keys';
import * as ACTIONS from '../../../redux/actions';
import {
  getReportByNamespaceReturn,
  getReportByNamespaceSuccess,
  updateDeviceReportsCauseReturn,
  updateDeviceReportsCauseSuccess
} from '../../../redux/actions';
import storageService from '../../../services/storage.service';
import './index.scss';

const convertFilterToParams = (filter) => {
  const { fromDate, toDate, ...restFilter } = filter;
  return {
    ...restFilter,
    fromTime: fromDate.startOf('day').valueOf(),
    toTime: toDate.endOf('day').valueOf(),
  };
};

const SystemMessage = ({ handleClosePopup }) => {
  const dispatch = useDispatch();
  const notificationContainer = useRef();
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const reportByNamespace = useSelector((state) => state.reportByNamespace);
  const updateDeviceReportsCause = useSelector(
    (state) => state.updateDeviceReportsCause
  );
  const { namespace } = useSelector((state) => state);
  const [openUpdateCause, setOpenUpdateCause] = useState(true);
  const [size] = useState(300);
  const [loading, setLoading] = useState(false);
  const [loadingUpdateCause, setLoadingUpdateCause] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [deviceType, setDeviceType] = useState('camera');
  const [defaultDate] = useState(moment());
  const [causeForm] = Form.useForm();

  const listTimeTag = useMemo(() => {
    return [
      {
        id: 0,
        title: 'Today',
        fromDate: defaultDate,
        toDate: defaultDate,
      },
      {
        id: 1,
        title: '1 day ago',
        fromDate: defaultDate.clone().subtract(1, 'days'),
        toDate: defaultDate,
      },
      {
        id: 2,
        title: '7 days ago',
        fromDate: defaultDate.clone().subtract(7, 'days'),
        toDate: defaultDate,
      },
      {
        id: 3,
        title: '1 month ago',
        fromDate: defaultDate.clone().subtract(1, 'months'),
        toDate: defaultDate,
      },
    ];
  }, [defaultDate]);

  const listOptionCause = useMemo(() => {
    return [
      {
        id: 'treobox',
        title: 'Treo Box',
      },
      {
        id: 'hongbox',
        title: 'Hỏng Box',
      },
      {
        id: 'matdien',
        title: 'Mất điện',
      },
      { id: 'loiswitch', title: 'Lỗi switch' },
      {
        id: 'loicamera',
        title: 'Lỗi Camera',
      },
      {
        id: 'loikenhtruyen',
        title: 'Lỗi kênh truyền',
      },
      {
        id: 'loihethong',
        title: 'Lỗi hệ thống',
      },
    ];
  }, []);

  const [timeTag, setTimeTag] = useState(listTimeTag[0]);
  const [optionCause, setOptionCause] = useState('');
  const [eventCause, setEventCause] = useState('Tất cả');
  const [filter, setFilter] = useState({
    customerNamespace: namespace,
    isDownload: 0,
    limit: size,
    offset: 0,
    fromDate: listTimeTag[0].fromDate,
    toDate: listTimeTag[0].toDate,
    minSecond: 10000,
    deviceType: 'camera',
  });

  const handleDateRangerChange = (values) => {
    const FromDate =
      values.length > 0 ? values[0].set({ hour: 0, minute: 0, second: 0 }) : '';
    const ToDate =
      values.length > 0
        ? values[1].set({ hour: 23, minute: 59, second: 59 })
        : '';
    setTimeTag(null);
    setFilter((prev) => ({
      ...prev,
      limit: size,
      fromDate: moment(FromDate),
      toDate: moment(ToDate),
    }));
    if (notificationContainer.current)
      notificationContainer.current.scrollTop = 0;
    handleCloseUpdateCause();
  };

  const handleScroll = (e) => {
    if (loading) return;
    // BUG BE currently does not support pagination
    // Should check limit to avoid loading forever: reportByNamespace?.deviceReports?.length >= filter.limit
    const isBottom =
      Math.ceil(e.target.scrollTop) + e.target.clientHeight >=
      e.target.scrollHeight;
    if (isBottom) {
      setFilter((prev) => ({
        ...prev,
        limit: prev.limit + size,
      }));
    }
  };

  const handleDownloadSystemMessages = async () => {
    setIsLoadingExport(true);
    const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
    const namespace = localStorage.getItem('namespace');
    try {
      const dataRes = await getReportByNamespaceApi(
        token,
        { namespace },
        {
          ...convertFilterToParams(filter),
          offset: 0,
          limit: 10000000, // TODO should fix later
          isDownload: 1,
          deviceType,
        }
      );
      setTimeout(() => {
        if (dataRes?.data) {
          const buttonElement = document.createElement('a');
          buttonElement.href = `data:text/csv;charset=utf-8,${encodeURI(
            dataRes.data
          )}`;
          buttonElement.target = '_blank';
          buttonElement.download = `${deviceType}.report-by-namespace.${filter.fromDate.format(
            'DD_MM_YYYY'
          )}-${filter.toDate.format('DD_MM_YYYY')}.csv`;
          buttonElement.click();
        } else {
          ACTIONS.openMessage(NOTIFIES.WARNING, 'No data export');
        }
        setIsLoadingExport(false);
      }, 800);
    } catch (error) {
      ACTIONS.openMessage(NOTIFIES.WARNING, 'Error when exporting file');
      setIsLoadingExport(false);
    }
  };

  const handleClickTimeTag = (timeTagItem) => {
    if (timeTagItem.id === timeTag?.id) {
      return;
    }
    setTimeTag(timeTagItem);
    setFilter((prev) => ({
      ...prev,
      limit: size,
      fromDate: timeTagItem.fromDate,
      toDate: timeTagItem.toDate,
    }));
    if (notificationContainer.current)
      notificationContainer.current.scrollTop = 0;
    handleCloseUpdateCause();
  };

  const handleChangeDeviceType = (dType) => {
    setDeviceType(dType);
    if (dType === 'gateway') {
      setFilter((prev) => ({
        ...prev,
        minSecond: 0,
        limit: size,
        deviceType: dType,
      }));
    } else {
      console.log('camera');

      setFilter((prev) => ({
        ...prev,
        minSecond: 10000,
        limit: size,
        deviceType: dType,
      }));
    }

    if (notificationContainer.current)
      notificationContainer.current.scrollTop = 0;
    handleCloseUpdateCause();
  };

  const handleChangeChecked = (eventId) => {
    setSelectedItems((prev) => xor(prev, [eventId]));
  };

  const handleClickOptionCause = (timeTagItem) => {
    if (timeTagItem.title === optionCause) {
      setOptionCause('');
    } else {
      setOptionCause(timeTagItem.title);
    }
  };

  const handleSubmitCause = (formValues) => {
    if (!optionCause) {
      return;
    }

    setLoadingUpdateCause(true);
    const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
    const namespace = localStorage.getItem('namespace');
    dispatch(
      updateDeviceReportsCauseReturn({
        token,
        namespace,
        dataBody: {
          eventIds: selectedItems.join(';'),
          namespace: namespace,
          cause: optionCause,
        },
      })
    );
  };

  const getListSystemMessage = useCallback(() => {
    setLoading(true);
    const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
    const namespace = localStorage.getItem('namespace');

    dispatch(
      getReportByNamespaceReturn({
        token,
        namespace,
        dataQuery: convertFilterToParams(filter),
      })
    );
  }, [dispatch, filter]);

  const handleOpenUpdateCause = (eventId) => {
    setSelectedItems([eventId]);
  };

  const handleCloseUpdateCause = () => {
    if (openUpdateCause) {
      setSelectedItems([]);
      causeForm.resetFields();
    }
  };

  const numberItems = reportByNamespace?.deviceReports?.length; // to scroll load more forever

  useEffect(() => {
    if (reportByNamespace) {
      setLoading(false);
    }
  }, [reportByNamespace]);

  useEffect(() => {
    if (updateDeviceReportsCause) {
      setLoadingUpdateCause(false);
      setFilter((prev) => ({ ...prev }));
    }
  }, [updateDeviceReportsCause]);

  useEffect(() => {
    getListSystemMessage();
  }, [getListSystemMessage]);

  useEffect(() => {
    return () => {
      dispatch(getReportByNamespaceSuccess(null));
      dispatch(updateDeviceReportsCauseSuccess(null));
    };
  }, [dispatch]);

  return (
    <Spin spinning={loading}>
      <div className="system_message_popup_header">
        <CloseCircleOutlined
          className="popup_close_icon"
          onClick={handleClosePopup}
          alt="Close"
        />
        <Space direction="vertical" style={{ marginTop: '20px' }}>
          <div>
            <div className="filter-options">
              <Space size="small">
                {listTimeTag.map((timeTagItem) => (
                  <Tag
                    key={timeTagItem.id}
                    onClick={() => handleClickTimeTag(timeTagItem)}
                    style={{
                      cursor: 'pointer',
                      ...(timeTag?.id === timeTagItem.id && {
                        color: '#fd9113',
                        borderColor: '#fd9113',
                      }),
                    }}
                  >
                    {timeTagItem.title}
                  </Tag>
                ))}
                <DatePicker.RangePicker
                  allowClear={false}
                  value={[filter.fromDate, filter.toDate]}
                  format="DD-MM-YYYY"
                  onChange={handleDateRangerChange}
                />
              </Space>
            </div>
          </div>
          <div className="message-tabs">
            <Tabs onChange={(activeKey) => handleChangeDeviceType(activeKey)}>
              <Tabs.TabPane tab="Camera" key="camera"></Tabs.TabPane>
              <Tabs.TabPane tab="Gateway" key="gateway"></Tabs.TabPane>
            </Tabs>
            <Button
              loading={isLoadingExport}
              icon={<DownloadOutlined />}
              size="small"
              onClick={handleDownloadSystemMessages}
              className="button_download"
            >
              Download
            </Button>
          </div>
        </Space>
      </div>
      <div
        className="notification_container_system_message"
        onScroll={handleScroll}
        ref={notificationContainer}
      >
        {reportByNamespace?.deviceReports?.map((messageItem, index) => (
          <MessageItem
            messageItem={messageItem}
            key={index}
            checked={selectedItems.includes(messageItem.eventId)}
            onChangeChecked={() => handleChangeChecked(messageItem.eventId)}
            openUpdateCause={openUpdateCause}
            onClickMenuUpdateCause={() =>
              handleOpenUpdateCause(messageItem.eventId)
            }
          />
        ))}
        {reportByNamespace?.deviceReports?.length === 0 && <Empty />}
        {!!numberItems && numberItems < 3 && <div style={{ height: 300 }} />}
      </div>
      {openUpdateCause && selectedItems.length > 0 && (
        <div className="system_message_update_cause_container">
          <Form onFinish={handleSubmitCause} form={causeForm}>
            <Space
              size="small"
              style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '4px' }}
            >
              {listOptionCause.map((timeTagItem) => (
                <Tag
                  key={timeTagItem.id}
                  onClick={() => handleClickOptionCause(timeTagItem)}
                  style={{
                    cursor: 'pointer',
                    marginRight: 0,
                    ...(optionCause === timeTagItem.title && {
                      color: '#288cff',
                      borderColor: '#288cff',
                    }),
                  }}
                >
                  {timeTagItem.title}
                </Tag>
              ))}
            </Space>
            <Space className="system_message_update_cause_actions">
              <Button
                size="small"
                type="primary"
                htmlType="submit"
                loading={loadingUpdateCause}
                disabled={selectedItems.length === 0}
                onClick={() => console.log('Enter')}
              >
                Confirm
              </Button>
              <Button size="small" type="text" onClick={handleCloseUpdateCause}>
                Cancel
              </Button>
            </Space>
          </Form>
        </div>
      )}
    </Spin>
  );
};
const MessageItem = ({
  messageItem,
  checked,
  onChangeChecked,
  openUpdateCause,
  onClickMenuUpdateCause,
}) => {
  return (
    <div>
      <div className="system_message_header">
        <Space size="middle" style={{ display: 'flex' }}>
          <div className="system_message_icon">
            <MailOutlined />
          </div>
          <div>
            <div className="system_message_title">System Message</div>
            <div className="system_message_date">
              {moment(messageItem.createdAt).format('DD/MM/YYYY HH:mm')}
            </div>
          </div>
        </Space>
        <div>
          {!openUpdateCause && (
            <Dropdown
              overlay={
                <Menu className="system_message_menu">
                  <Menu.Item onClick={onClickMenuUpdateCause}>
                    <PlusOutlined /> Update cause
                  </Menu.Item>
                </Menu>
              }
            >
              <DownSquareOutlined className="system_message_menu_icon" />
            </Dropdown>
          )}
          {openUpdateCause && (
            <Checkbox checked={checked} onChange={onChangeChecked} />
          )}
        </div>
      </div>
      <div className="system_message_description">{messageItem.message}</div>
      {!!messageItem.cause && (
        <div className="system_message_cause">Cause: {messageItem.cause}</div>
      )}
      <Divider />
    </div>
  );
};
export default SystemMessage;
